// extracted by mini-css-extract-plugin
export default {"user_info_content":"index_user_info_content__LV-1c","avatar":"index_avatar__JQiHR","user_info":"index_user_info__Voa7t","account":"index_account__XFa33","num":"index_num__qBrOE"};